export default "__VITE_ASSET__accb49c9__"